import makeSlice from '@web/slices/expenseDetails/sliceMaker'

const slice = makeSlice()

export default slice.reducer
